import { gql } from "@apollo/client";

export interface IDebtAmountInfoPayload {
  acn: string;
  fine: number;
  eeResumption: number;
  eeRepresentation: number;
  eeReference: number;
  eePostCost: number;
  eeHalting: number;
  stateFee: number;
  restOfBasicDebt: number;
  qrd: string;
}

export const debtAmountQuery = () => {
  return {
    query: gql`
      query GetDebtAmountInfo(
        $acn: String!
        $fine: Decimal!
        $eeResumption: Decimal!
        $eeRepresentation: Decimal!
        $eeReference: Decimal!
        $eePostCost: Decimal!
        $eeHalting: Decimal!
        $stateFee: Decimal!
        $restOfBasicDebt: Decimal!
        $qrd: Date!
      ) {
        getDebtAmountInfo(
          acn: $acn
          fine: $fine
          eeResumption: $eeResumption
          eeRepresentation: $eeRepresentation
          eeReference: $eeReference
          eePostCost: $eePostCost
          eeHalting: $eeHalting
          stateFee: $stateFee
          restOfBasicDebt: $restOfBasicDebt
          qrd: $qrd
        ) {
          paymentId
          isDebtAmountInfoOld
          # debtAddress
          accountNumber
          debtInfoDate
          debtsAmountInfo {
            supplierName
            supplierGuid
            sumRestOfBasicDebt
            stateFee
            sumFine
            eePostCost
            extraExpensesWithoutPostCost
          }
        }
      }
    `,
  };
};
